import request, { ResponseProps } from '@/utils/request';

// 提交订单
// 支付渠道： alipay_pc_direct | stripe | alipay_qr | wx_qr
export const orderPay = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dlt/commerce/prepayment', {
    method: 'POST',
    data,
  });
  return res;
};

// 轮训订单结果
export const orderPolling = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dlt/commerce/order/query', {
    method: 'POST',
    data,
  });
  return res;
};

type StripePayResult = {
  [K in keyof ResponseProps]: K extends 'data'
    ? {
        amount: number;
        contractCode: string;
        currencyCode: string;
        redirectUrl: string;
        subscribeId: string;
      }
    : ResponseProps[K];
};
// stripe支付
export const stripeOrderPay = async (data: {}): Promise<StripePayResult> => {
  const res: StripePayResult = await request('/api/rest/dlt/commerce/subscribe', {
    method: 'POST',
    data,
  });
  return res;
};

type StripePayDetail = {
  [K in keyof ResponseProps]: K extends 'data'
    ? {
        status: 'SUCCESS' | 'CANCEL' | 'UNKNOWN' | 'FAILED' | undefined | null;
        redirectUrl: string;
        expireTime: number;
      }
    : ResponseProps[K];
};
// stripe 订阅状态查询
export const stripeOrderDetail = async (data?: {}): Promise<StripePayDetail> => {
  const res: StripePayDetail = await request('/api/rest/dlt/commerce/thirdStatus', {
    method: 'POST',
    data,
  });
  return res;
};
